"use client";

import { c as _c } from "react/compiler-runtime";
import { createDeferredPromise } from "@opensea/utils";
import { useWallet } from "@solana/wallet-adapter-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { SOLANA_CHAIN_ID } from "../../constants";

/**
 * Used to connect a solana wallet with a callback that resolves when the wallet is connected
 */
export function useConnectSolanaWallet() {
  const $ = _c(10);
  const {
    wallet,
    select: selectSolanaWallet,
    connect: connectSolanaWallet
  } = useWallet();
  const selectSolanaWalletRef = useRef(selectSolanaWallet);
  let t0;
  let t1;
  if ($[0] !== selectSolanaWallet) {
    t0 = () => {
      selectSolanaWalletRef.current = selectSolanaWallet;
    };
    t1 = [selectSolanaWallet];
    $[0] = selectSolanaWallet;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const [solanaConnectingWallet, setSolanaConnectingWallet] = useState();
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = createDeferredPromise();
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const solanaConnectPromiseRef = useRef(t2);
  let t3;
  let t4;
  if ($[4] !== connectSolanaWallet || $[5] !== solanaConnectingWallet || $[6] !== wallet) {
    t3 = () => {
      if (solanaConnectingWallet && solanaConnectingWallet === wallet?.adapter.name) {
        connectSolanaWallet().then(() => {
          solanaConnectPromiseRef.current.resolve({
            accounts: [wallet.adapter.publicKey?.toString() ?? ""],
            chainId: SOLANA_CHAIN_ID
          });
        }).catch(solanaConnectPromiseRef.current.reject).finally(() => {
          solanaConnectPromiseRef.current = createDeferredPromise();
          setSolanaConnectingWallet(undefined);
        });
      }
    };
    t4 = [wallet, solanaConnectingWallet, connectSolanaWallet];
    $[4] = connectSolanaWallet;
    $[5] = solanaConnectingWallet;
    $[6] = wallet;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = async connectorId => {
      selectSolanaWalletRef.current(connectorId);
      setSolanaConnectingWallet(connectorId);
      return solanaConnectPromiseRef.current.promise;
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}